function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import I18N from '@leverege/i18n';
import { Flex, Label } from '@leverege/ui-elements';
import CardGridView from "./CardGridView.js";
import { Grid } from "../model/index.js";
import DashboardContext, { useDashboardContext } from "../shared/DashboardContext.js";
import VariantCreator from "../shared/VariantCreator.js";
const {
  t
} = I18N.ns('uiDashboard.view.GridView');
export default function GridView(props) {
  const [optionOverrides, setOptionOverides] = useState(null);
  const {
    value: v,
    onChange,
    eventData
  } = props;
  const value = v || {};
  const {
    style,
    className,
    ...rProps
  } = props;
  const dashboardContext = useDashboardContext();
  const {
    models,
    optionEditors,
    depth,
    sharedProps,
    options
  } = dashboardContext;
  const ovc = new VariantCreator('OptionsView', value.style);
  const mdl = depth === 0 && models.create(value);
  const showOpts = !mdl?.getShowOptions || mdl.getShowOptions(value) === true;
  const req = mdl && mdl.getRequired && mdl.getRequired(value, models, dashboardContext);
  const opt = value.options != null || optionOverrides != null || options != null ? {
    ...(options || {}),
    ...(value.options || {}),
    ...(optionOverrides || {})
  } : null;
  if (showOpts && req && req.length > 0) {
    return /*#__PURE__*/React.createElement(DashboardContext, {
      depth: depth + 1,
      options: opt,
      columns: Grid.getColumns(value) || 2
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "colM",
      align: "right"
    }, /*#__PURE__*/React.createElement(Flex, {
      align: "center",
      variant: `${ovc.get()}|rowM`
    }, /*#__PURE__*/React.createElement(Label, null, t('dashboardOptions')), req.map(req => {
      const onChange = evt => {
        const options = {
          ...opt
        };
        options[req] = evt.value;
        setOptionOverides(options);
      };
      const oProps = {
        key: req,
        eventData: req,
        value: opt[req],
        sharedProps,
        onChange
      };
      return optionEditors.create(req, oProps);
    })), /*#__PURE__*/React.createElement(CardGridView, _extends({}, rProps, {
      onChange: onChange,
      eventData: eventData
    }))));
  }
  return /*#__PURE__*/React.createElement(DashboardContext, {
    depth: depth + 1,
    options: opt
  }, /*#__PURE__*/React.createElement(CardGridView, _extends({}, rProps, {
    onChange: onChange,
    eventData: eventData
  })));
}
GridView.NAME = 'Grid';